export default __webpack_public_path__ + "static/media/child.f4ed486a.svg";